import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'grid',
    placeItems: 'center',
    borderRadius: '8px',
    minWidth: '240px',
    width: '240px',
    maxWidth: '240px',
    minHeight: '64px',
    height: '64px',
    maxHeight: '64px',
    background: theme.palette.primary.main
  },

  content: {
    display: 'flex',
    alignItems: 'center',
    width: 'calc(100% - 32px)'
  },

  icon: {
    marginRight: '8px'
  },

  info: {
    flex: '1',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  },

  title: {
    maxWidth: '180px',
    fontSize: theme.size.base,
    color: 'white'
  },

  type: {
    marginTop: '2px',
    fontSize: theme.size.sm,
    opacity: '0.7'
  }
}))

export default useStyles
